// Plugins
import Vue from 'vue';
import VueI18n from 'vue-i18n';

// Locales
import messages from '@/locales';

// Constants
import { DEFAULT_LOCALE, readStoredLocale, applyDocumentLocale } from '@/constants/locale-constants';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: readStoredLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages,
  silentTranslationWarn: true
});

applyDocumentLocale(i18n.locale);

export default i18n;
